import React from 'react';

interface PaymentButtonProps {
  isFormValid: boolean;
  isProcessing: boolean;
  isScheduled: boolean;
  onClick: () => void;
}

export const PaymentButton: React.FC<PaymentButtonProps> = ({
  isFormValid,
  isProcessing,
  isScheduled,
  onClick
}) => {
  return (
    <button
      id="btn-pay"
      className={`w-full py-2.5 sm:py-3 font-bold text-sm sm:text-base uppercase rounded-md flex items-center justify-center mt-4 transition-colors duration-200 ${
        isFormValid && !isProcessing
          ? 'bg-blue-600 hover:bg-blue-700 text-white cursor-pointer' 
          : 'bg-gray-300 text-gray-500 cursor-not-allowed'
      }`}
      disabled={!isFormValid || isProcessing}
      onClick={onClick}
    >
      <img
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAPxJREFUSEvtldGNwjAMhr9/AnQTAJNwbMAG9CZATAC3ARvABjACN8mVDW4DI6Mg9VqStEWVeMAvjSrb3x8ndsTApoHz0wpgZgtgBXwGQWfgW5J/k5YFmNkBWEayOGSbIiQBQfkxJFgDp7AugE1Yz1M7yQG8BDNgLWlXVWpmrtwhP5LupWtsJgewEPEh6a8GmAC//k9SNE8rQCyBmd0EDAbI3aAbPOXURmEO0gCYmR/YHvAad7ES+KrfqEcAdxx3yVzxLSVNq7GPAPeb04tRP/A3oNm5taZ7l+g1S+RTc9SrCeAi6d8EiI0Kf8W6dvMFKLKjoqfyaFj2TX4WeAX0MmsZ8nx06AAAAABJRU5ErkJggg=="
        alt="Save Payment Icon"
        className="mr-2 w-4 h-4 sm:w-5 sm:h-5"
      />
      {isScheduled ? 'Schedule Payment' : 'Pay'}
    </button>
  );
}; 